import { Form } from 'vant'
import fetch from './fetch'

const bigToastProps = {
	duration: 5000,
	className: 'tkon-toast'
}

export function getPrice(data) {
	return fetch({
		url: 'tkProduct/getPrice',
		method: 'post',
		headers: {
			'Content-Type': 'application/json'
		},
		data: {
			spuId: '1761948169345594455'
		}
	})
}

// 营业执照识别
export function licenseOcr({ fileId }) {
	return fetch({
		url: 'insurance/licenseOcr',
		method: 'get',
		params: { fileId }
	})
}
// 文件上传
export function uploadFile(data) {
	const fd = new FormData()
	for (let key in data) {
		fd.append(key, data[key])
	}
	return fetch({
		url: 'insurance/uploadFile',
		method: 'post',
		data: fd,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	})
}
// 识别身份证
export function idCardOcr(params) {
	return fetch({
		url: 'insurance/idCardOcr',
		method: 'post',
		params,
		data: params,
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
// 识别行驶证
export function driveOcr(params) {
	return fetch({
		url: 'insurance/driveOcr',
		method: 'post',
		params,
		data: params,
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
export function productDetail(productId) {
	return fetch({
		url: 'insurance/product/productDetail',
		method: 'get',
		params: { productId },
		toastProps: bigToastProps
	})
}
// 去支付
export function goPay(businessId, data) {
	return fetch({
		url: 'insurance/insure/goPay',
		method: 'post',
		data,
		params: { businessId },
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
// 生成订单号
export function createBusiness(params) {
	return fetch({
		url: 'insurance/insure/createBusiness',
		method: 'get',
		params
	})
}

// 生成订单
export function saveInsuranceInfoByYG(data) {
	return fetch({
		url: 'insurance/saveInsuranceInfoByYG',
		method: 'post',
		data,
		headers: {
			'Content-Type': 'application/json'
		}
	})
}
